
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

import * as actions from '../../../actionTypes'
import {selectedFactorIndices} from '../../../selectors'
import FactorList from './FactorList'
import ActionModal from '../../common/ActionModal'
import FormHeader from '../FormHeader'


class TopThreeFactorContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isWarningModalVisible: false,
      isToggleWarningModalVisible: false,
      factorToRemove: null,
      checkedItems: props.selectedFactorIndices
    }
  }

  componentDidMount() {
    this.configureNavigation()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.topThreeFactors !== this.props.topThreeFactors) {
      if(!this.state.checkedItems.length) {
        this.setState({checkedItems: this.props.selectedFactorIndices})
      }
      this.configureNavigation()
    }
  }

  configureNavigation() {
    const {navigator, topThreeFactors} = this.props
    if(topThreeFactors.length < 3) {
      navigator.disableForward()
    } else {
      navigator.enableForward()
    }
  }

  onFactorClick = ({isDisabled, factor, index}) => {
    if(isDisabled) {
      this.setState({isWarningModalVisible: true})
    } else {
      const { topThreeFactorsWithAffectWeights } = this.props
      const hasPreviousData = topThreeFactorsWithAffectWeights.some(ele => ele.weight !== 0)
      const checkedItemsStateIndex = this.state.checkedItems.indexOf(index)
      const arrayAction = checkedItemsStateIndex > -1 ? 'remove' : 'add'
      // User has come back and is changing the top 3 after setting weights/ranking
      if (arrayAction === 'remove' && hasPreviousData) {
        return this.setState({
          isToggleWarningModalVisible: true,
          factorToRemove: {
            index,
            factor,
            checkedItemsStateIndex
          }
        })
      }
      this.props.onFactorClick(factor, arrayAction)
      this.updateCheckedItemsState(index, checkedItemsStateIndex, arrayAction)
    }
  }

  complexFactorRemove = () => {
    const { factor, index, checkedItemsStateIndex } = this.state.factorToRemove
    this.props.onFactorClick(factor, 'remove')
    this.updateCheckedItemsState(index, checkedItemsStateIndex, 'remove')
    this.setState({
      isToggleWarningModalVisible: false,
      factorToRemove: null
    })
  }

  updateCheckedItemsState = (index, checkedItemsStateIndex, arrayAction) => {
    const slicedCheckedItems = this.state.checkedItems.slice()
    if (arrayAction === 'remove') {
      slicedCheckedItems.splice(checkedItemsStateIndex, 1)
    } else if (arrayAction === 'add') {
      slicedCheckedItems.push(index)
    }
    this.setState({checkedItems: slicedCheckedItems})
  }

  render() {
    const {isCounselingSessionDisabled, t, navigator} = this.props
    return (
      <React.Fragment>
        <Grid
          alignContent="flex-start"
          className="counseling-session-page-container"
          container
          justify="center"
          spacing={8}
        >
        <FormHeader
          description={t('Top Three Factors')}
          stepNumber={t(`Step ${navigator.getStepNumber()}`)}
        />
          <Grid item xs={10}>
            <FactorList
              checkedItems={this.state.checkedItems}
              factors={this.props.factors}
              isCounselingSessionDisabled={isCounselingSessionDisabled}
              onFactorClick={this.onFactorClick}
              sessionComplete={this.props.sessionComplete}
              topThreeFactors={this.props.topThreeFactors}
            />
          </Grid>
        </Grid>
        {this.renderWarningModal()}
        {this.renderToggleWarningModal()}
      </React.Fragment>
    )
  }

  renderToggleWarningModal() {
    const modalContent = 'Top Three Warning'
    const buttonText = 'Cancel'
    const {t} = this.props
    const buttons = [
      <Button onClick={this.complexFactorRemove}>{t('Continue')}</Button>
    ]

    return (
      <ActionModal
        content={t(modalContent)}
        dismissText={t(buttonText)}
        open={this.state.isToggleWarningModalVisible}
        onDismiss={() => this.setState({isToggleWarningModalVisible: false})}
        buttons={buttons}
      />
    )
  }

  renderWarningModal() {
    const modalContent = 'Too Many Factors'
    const buttonText = 'Ok'
    const {t} = this.props

    return (
      <ActionModal
        content={t(modalContent)}
        dismissText={t(buttonText)}
        open={this.state.isWarningModalVisible}
        onDismiss={() => this.setState({isWarningModalVisible: false})}
      />
    )
  }
}

const mapStateToProps = state => ({
  factors: state.counselingSession.counselingSessionData.factorsOption1.concat(state.counselingSession.counselingSessionData.factorsOption2),
  selectedFactorIndices: selectedFactorIndices(state.counselingSession.counselingSessionData),
  topThreeFactors: state.counselingSession.counselingSessionData.topThreeFactors,
  topThreeFactorsWithAffectWeights: state.counselingSession.counselingSessionData.topThreeFactorsWithAffectWeights
})

const mapDispatchToProps = dispatch => ({
  onFactorClick(factorString, arrayAction) {
    this.resetAffectCompareArrays()
    this.resetFinalWeight()
    this.resetHasBeenRanked()
    const action = {type: actions.TOP_THREE_FACTORS_TOGGLE, payload: {factorString, arrayAction}}
    dispatch(action)
  },
  resetAffectCompareArrays() {
    const action = {type: actions.RESET_AFFECT_COMPARE_ARRAYS}
    dispatch(action)
  },
  resetFinalWeight() {
    const action = {type: actions.RESET_FINAL_WEIGHT}
    dispatch(action)
  },
  resetHasBeenRanked() {
    dispatch({ type: actions.RESET_HAS_BEEN_RANKED })
  }
})

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(TopThreeFactorContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/top-three-factors/TopThreeFactorContainer.js